export { default } from './ShelfTitleBar';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfTitleBar/index.js